import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { motion } from 'framer-motion';
import { ReactComponent as CloseIcon } from 'assets/heroicons/icon-x.svg';

interface Props {
  button: (show: any) => JSX.Element;
  content: (hide: any) => JSX.Element;
  footer: (hide: any) => JSX.Element;
  title?: string;
  autoOpen?: boolean;
  onClose?: () => any;
  onOpen?: () => any;
  style?: any;
}

const Modal = ({
  button,
  content,
  footer,
  title = '',
  autoOpen = false,
  onClose,
  onOpen,
}: Props) => {
  const [modalVisible, setModalVisible] = useState(autoOpen);
  const show = () => {
    onOpen && onOpen();
    setModalVisible(true);
  };
  const hide = () => {
    onClose && onClose();
    setModalVisible(false);
  };

  return (
    <>
      {button(show)}
      {modalVisible &&
        document.getElementById('modal') &&
        ReactDOM.createPortal(
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-40 flex items-center justify-center bg-smoke-300"
          >
            <motion.aside
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.5, opacity: 0 }}
              transition={{ delay: 0.1, duration: 0.2 }}
              className="flex flex-col justify-between w-full max-w-2xl bg-gray-100 rounded-lg shadow-xl pointer-events-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <header className="flex items-center justify-between flex-shrink-0 h-20 pl-6 pr-3">
                <h2 className="text-lg font-semibold text-gray-700">{title}</h2>
                <CloseIcon
                  className="w-12 h-12 p-1 text-gray-700 rounded-full cursor-pointer hover:text-black"
                  onClick={hide}
                />
              </header>
              <main className="flex-grow flex-shrink-0 px-6">
                {content(hide)}
              </main>
              <footer className="flex items-center justify-end flex-shrink-0 p-6">
                {footer(hide)}
              </footer>
            </motion.aside>
          </motion.div>,
          document.getElementById('modal'),
        )}
    </>
  );
};

export default Modal;
